<template>
    <div class="transactionRecordBody">
        <div class="header">
            <span :class="{ order: index == orderindex }" v-for="(item, index) in header" :key="index"
                @click="transactionRecordHeader(index)">{{ item }}</span>
        </div>

        <div class="user_skills">
            <el-table :data="tableData" style="width: 100%" class="transparent-table">
                <el-table-column prop="date" label="日期" width="180" align="center">
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="180" align="center">
                </el-table-column>
                <el-table-column prop="address" label="地址" align="center">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>

import Cookies from "js-cookie";
export default {
    components: {

    },
    props: {
        type: '',
    },
    data() {
        return {
            header: ['购买记录', '赠送记录', '领取记录', '分解记录', '道具发送记录'],
            orderindex: 0,
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }]
        }
    },
    created() {

    },
    mounted() {
        // this.winResize()
    },
    methods: {
        transactionRecordHeader(index) {
            console.log(this.orderindex = index);

        }

    },
}
</script>

<style scoped lang="less">
.header {
    background: rgba(255, 255, 255, 0.5);
    border-radius: 2px 2px 2px 2px;
    border: 2px solid #5472F6;
    display: flex;
    justify-content: space-around;
    margin-bottom: 15px;

    span {
        line-height: 40px;
        cursor: pointer;
    }

    .order {
        color: #5472F6;
        font-size: 18px;
    }

}


.user_skills {
    margin: auto;
    border: #5472F6 2px solid;
}

.user_skills /deep/ .el-table--fit {}

.user_skills /deep/ .el-table,
.el-table__expanded-cell {
    background-color: transparent;
}

.user_skills /deep/ .el-table tr {
    background-color: transparent !important;
}

.user_skills /deep/ .el-table--enable-row-transition .el-table__body td,
.el-table .cell {
    background-color: transparent;
}

.el-table::before {
    //去除底部白线
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
}

/deep/.el-table th.el-table__cell {
    background-color: transparent !important;
    border-bottom: #5472F6 2px solid;
    color: #000;

    div {
        font-size: 20px;
    }

}

/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: none;
    color: #000;
}
</style>
